import { useMutation } from "@tanstack/react-query";
import { useApiClient } from "@src/packages/api/louise-api";

export function useSendBetaInvite() {
  const { client } = useApiClient();

  return useMutation({
    mutationFn: async () => {
      const { data, error } = await client.POST("/beta-invites/send");
      if (error) {
        throw new Error(
          typeof error === "string" ? error : JSON.stringify(error),
        );
      }
      return data?.data;
    },
  });
}
